import { watch as S, getCurrentScope as j, onScopeDispose as L, onMounted as z, nextTick as G, getCurrentInstance as A, computed as R, toValue as O, shallowRef as m, unref as D } from "vue";
function E(e) {
  return j() ? (L(e), !0) : !1;
}
const F = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const I = (e) => e != null, H = Object.prototype.toString, P = (e) => H.call(e) === "[object Object]", W = () => {
};
function y(e) {
  return Array.isArray(e) ? e : [e];
}
function V(e) {
  return A();
}
function k(e, o = !0, i) {
  V() ? z(e, i) : o ? e() : G(e);
}
function $(e, o, i) {
  return S(
    e,
    o,
    {
      ...i,
      immediate: !0
    }
  );
}
const M = F ? window : void 0;
function h(e) {
  var o;
  const i = O(e);
  return (o = i?.$el) != null ? o : i;
}
function C(...e) {
  const o = [], i = () => {
    o.forEach((n) => n()), o.length = 0;
  }, d = (n, s, c, u) => (n.addEventListener(s, c, u), () => n.removeEventListener(s, c, u)), p = R(() => {
    const n = y(O(e[0])).filter((s) => s != null);
    return n.every((s) => typeof s != "string") ? n : void 0;
  }), l = $(
    () => {
      var n, s;
      return [
        (s = (n = p.value) == null ? void 0 : n.map((c) => h(c))) != null ? s : [M].filter((c) => c != null),
        y(O(p.value ? e[1] : e[0])),
        y(D(p.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        O(p.value ? e[3] : e[2])
      ];
    },
    ([n, s, c, u]) => {
      if (i(), !n?.length || !s?.length || !c?.length)
        return;
      const t = P(u) ? { ...u } : u;
      o.push(
        ...n.flatMap(
          (r) => s.flatMap(
            (f) => c.map((v) => d(r, f, v, t))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    l(), i();
  };
  return E(i), a;
}
function q() {
  const e = m(!1), o = A();
  return o && z(() => {
    e.value = !0;
  }, o), e;
}
function B(e) {
  const o = q();
  return R(() => (o.value, !!e()));
}
function N(e, o, i = {}) {
  const { window: d = M, ...p } = i;
  let l;
  const a = B(() => d && "MutationObserver" in d), n = () => {
    l && (l.disconnect(), l = void 0);
  }, s = R(() => {
    const r = O(e), f = y(r).map(h).filter(I);
    return new Set(f);
  }), c = S(
    () => s.value,
    (r) => {
      n(), a.value && r.size && (l = new MutationObserver(o), r.forEach((f) => l.observe(f, p)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => l?.takeRecords(), t = () => {
    c(), n();
  };
  return E(t), {
    isSupported: a,
    stop: t,
    takeRecords: u
  };
}
function T(e, o, i = {}) {
  const { window: d = M, ...p } = i;
  let l;
  const a = B(() => d && "ResizeObserver" in d), n = () => {
    l && (l.disconnect(), l = void 0);
  }, s = R(() => {
    const t = O(e);
    return Array.isArray(t) ? t.map((r) => h(r)) : [h(t)];
  }), c = S(
    s,
    (t) => {
      if (n(), a.value && d) {
        l = new ResizeObserver(o);
        for (const r of t)
          r && l.observe(r, p);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    n(), c();
  };
  return E(u), {
    isSupported: a,
    stop: u
  };
}
function J(e, o = {}) {
  const {
    reset: i = !0,
    windowResize: d = !0,
    windowScroll: p = !0,
    immediate: l = !0,
    updateTiming: a = "sync"
  } = o, n = m(0), s = m(0), c = m(0), u = m(0), t = m(0), r = m(0), f = m(0), v = m(0);
  function g() {
    const x = h(e);
    if (!x) {
      i && (n.value = 0, s.value = 0, c.value = 0, u.value = 0, t.value = 0, r.value = 0, f.value = 0, v.value = 0);
      return;
    }
    const w = x.getBoundingClientRect();
    n.value = w.height, s.value = w.bottom, c.value = w.left, u.value = w.right, t.value = w.top, r.value = w.width, f.value = w.x, v.value = w.y;
  }
  function b() {
    a === "sync" ? g() : a === "next-frame" && requestAnimationFrame(() => g());
  }
  return T(e, b), S(() => h(e), (x) => !x && b()), N(e, b, {
    attributeFilter: ["style", "class"]
  }), p && C("scroll", b, { capture: !0, passive: !0 }), d && C("resize", b, { passive: !0 }), k(() => {
    l && b();
  }), {
    height: n,
    bottom: s,
    left: c,
    right: u,
    top: t,
    width: r,
    x: f,
    y: v,
    update: b
  };
}
function K(e, o = { width: 0, height: 0 }, i = {}) {
  const { window: d = M, box: p = "content-box" } = i, l = R(() => {
    var t, r;
    return (r = (t = h(e)) == null ? void 0 : t.namespaceURI) == null ? void 0 : r.includes("svg");
  }), a = m(o.width), n = m(o.height), { stop: s } = T(
    e,
    ([t]) => {
      const r = p === "border-box" ? t.borderBoxSize : p === "content-box" ? t.contentBoxSize : t.devicePixelContentBoxSize;
      if (d && l.value) {
        const f = h(e);
        if (f) {
          const v = f.getBoundingClientRect();
          a.value = v.width, n.value = v.height;
        }
      } else if (r) {
        const f = y(r);
        a.value = f.reduce((v, { inlineSize: g }) => v + g, 0), n.value = f.reduce((v, { blockSize: g }) => v + g, 0);
      } else
        a.value = t.contentRect.width, n.value = t.contentRect.height;
    },
    i
  );
  k(() => {
    const t = h(e);
    t && (a.value = "offsetWidth" in t ? t.offsetWidth : o.width, n.value = "offsetHeight" in t ? t.offsetHeight : o.height);
  });
  const c = S(
    () => h(e),
    (t) => {
      a.value = t ? o.width : 0, n.value = t ? o.height : 0;
    }
  );
  function u() {
    s(), c();
  }
  return {
    width: a,
    height: n,
    stop: u
  };
}
function Q(e, o, i = {}) {
  const {
    root: d,
    rootMargin: p = "0px",
    threshold: l = 0,
    window: a = M,
    immediate: n = !0
  } = i, s = B(() => a && "IntersectionObserver" in a), c = R(() => {
    const v = O(e);
    return y(v).map(h).filter(I);
  });
  let u = W;
  const t = m(n), r = s.value ? S(
    () => [c.value, h(d), t.value],
    ([v, g]) => {
      if (u(), !t.value || !v.length)
        return;
      const b = new IntersectionObserver(
        o,
        {
          root: h(g),
          rootMargin: p,
          threshold: l
        }
      );
      v.forEach((x) => x && b.observe(x)), u = () => {
        b.disconnect(), u = W;
      };
    },
    { immediate: n, flush: "post" }
  ) : W, f = () => {
    u(), r(), t.value = !1;
  };
  return E(f), {
    isSupported: s,
    isActive: t,
    pause() {
      u(), t.value = !1;
    },
    resume() {
      t.value = !0;
    },
    stop: f
  };
}
export {
  Q as a,
  K as b,
  J as c,
  C as u
};
